import { Box, Button } from "@/components";
import { memo, type PropsWithChildren } from "react";
import { usePoints } from "@/hooks/points/usePoints";
import { twMerge } from "tailwind-merge";
import { formatDisplayCurrency } from "@/utils/format-currency";

const PortfolioCTABox = ({ children, className }: PropsWithChildren<{ className?: string }>) => {
    return (
        <Box
            className={twMerge(
                "bg-[rgba(26,114,113,0.08)] flex md:flex-row flex-col gap-4 h-full justify-between items-center p-6 border-[1px] border-[rgba(26,114,113,0.2)]",
                className,
            )}
            card
            shadow
        >
            {children}
        </Box>
    );
};

export const PortfolioMintMoreCTA = () => {
    return (
        <PortfolioCTABox>
            <div className="flex flex-col gap-2">
                <span className="text-primary text-[24px] font-medium leading-[28px]">Mint more iUSD</span>
                <span className="text-muted text-[14px] leading-[21px] font-normal">
                    Deposit USDC (or stablecoin) and mint iUSD in one step.
                </span>
            </div>
            <Button variant="primary" size="md" href="/mint" className="w-full md:w-auto">
                Deposit & Mint
            </Button>
        </PortfolioCTABox>
    );
};

const PortfolioPointsCTAComponent = () => {
    const { totalPassivePoints } = usePoints();
    return (
        <PortfolioCTABox className="bg-card">
            <div className="flex flex-col gap-4 md:gap-0 text-center md:text-left">
                <span className="text-primary text-[24px] font-medium leading-[28px]">Your Points</span>
                <span className="text-muted text-[18px] md:text-[14px] leading-[21px] font-normal">
                    {formatDisplayCurrency(totalPassivePoints)} pts
                </span>
            </div>
            <Button variant="primary" size="md" href="/points" className="w-full md:w-auto">
                View Points
            </Button>
        </PortfolioCTABox>
    );
};

export const PortfolioPointsCTA = memo(PortfolioPointsCTAComponent);

PortfolioPointsCTA.displayName = "PortfolioPointsCTA";
